import { DELIMITER_DOT } from '../constants';
import {
    type CharacteristicPartial,
    getAllCharacteristics,
    getAllCharacteristicsTitles,
    getGroupedCharacteristics,
} from './getGroupedCharacteristics';

const getBaseLine = (beforeText: string | undefined, characteristicsText: string) => {
    if (beforeText && characteristicsText) {
        return beforeText + DELIMITER_DOT + characteristicsText;
    }

    return beforeText || characteristicsText;
};

/*
 * Функция возвращает строку, состоящую из переданного текста + сгруппированных характеристик, в случае наличия обоих,
 * Либо только то, что имеется
 */
export const getGroupedCharacteristicsLine = (
    beforeText: string | undefined,
    characteristics: CharacteristicPartial[] | undefined
) => getBaseLine(beforeText, getGroupedCharacteristics(characteristics));

export const getAllCharacteristicsLine = (
    beforeText: string | undefined,
    characteristics: CharacteristicPartial[] | undefined
) => getBaseLine(beforeText, getAllCharacteristics(characteristics));

export const getAllCharacteristicsTitlesLine = (
    beforeText: string | undefined,
    characteristics: CharacteristicPartial[] | undefined
) => getBaseLine(beforeText, getAllCharacteristicsTitles(characteristics));
